import React from 'react'
import * as firebase from 'firebase';
import HttpClient from "../../utils/HttpClient/HttpClient";

export default class RegisterFirebase {

    config = {
        apiKey: "AIzaSyBil5j1j6-0Sb2LgeFfuN_CRRoGpqLxuaQ",
        authDomain: "oga-web-prod.firebaseapp.com",
        databaseURL: "https://oga-web-prod.firebaseio.com",
        projectId: "oga-web-prod",
        storageBucket: "oga-web-prod.appspot.com",
        messagingSenderId: "707480054841"
    };

    httpClient;
    constructor() {
        this.httpClient = new HttpClient(true);
    }

    register(cb) {
        if (!firebase.apps.length) {
            firebase.initializeApp(this.config);
        }

        let messaging;
        try {
            messaging = firebase.messaging();
        } catch (e) {
            console.error("Messaging not supported");
            return;
        }

        if (!messaging) return;

        // Check if notifications are supported
        if (!('Notification' in window)) {
            console.log('This browser does not support notifications');
            return;
        }

        const config = { headers: { 'Content-Type': 'text/plain' } };
        
        // Use modern Notification.requestPermission() API
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                console.log('Notification permission granted');
                return messaging.getToken();
            } else if (permission === 'denied') {
                console.log('Notification permission denied');
                return Promise.reject(new Error('Notification permission denied'));
            } else {
                console.log('Notification permission dismissed');
                return Promise.reject(new Error('Notification permission dismissed'));
            }
        }).then((token) => {
            if (token) {
                console.log('FCM registration token:', token);
                return this.httpClient.post("oga/firebase/register", token, config);
            }
        }).then(() => {
            console.log("oga/firebase/register succeed");
        }).catch((err) => {
            console.log("Firebase messaging registration skipped:", err.message);
            // Don't log as error since this is expected behavior when permissions are blocked
        });

        messaging.onMessage((res) => {
            res.data.notification = JSON.parse(res.data.notification);
            cb(res);
        });
    }

    deleteToken(logout) {
        let messaging;
        try {
            messaging = firebase.messaging();
            messaging.getToken().then(function (currentToken) {
                messaging.deleteToken(currentToken).then(function () {
                    logout();
                    console.log('Token deleted.');
                }).catch(function (err) {
                    console.log('Unable to delete token. ', err);
                });
            }).catch(function (err) {
                console.log('Error retrieving Instance ID token. ', err);
            });
        } catch (e) {
            console.error("Messaging not supported");
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/RegisterFirebase.jsx